import { Box, Card } from "@mui/material";
import { LICENSE_CODE_TO_DATA_MAP } from "Components/Licenses/licenseUtils";
import type { LicenseCode } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  code: LicenseCode;
  licenseNo: string;
  isSelected?: boolean;
  isDisabled?: boolean;
};

export const LicenseRadioOption = ({
  code,
  licenseNo,
  isSelected,
  isDisabled,
}: Props) => {
  const { t } = useResource();
  const label = `${LICENSE_CODE_TO_DATA_MAP[code].title} ${licenseNo ? `- No. ${licenseNo}` : ""}`;
  const imgSrc = LICENSE_CODE_TO_DATA_MAP[code].czImg;

  return (
    <Card
      sx={(theme) => ({
        display: "flex",
        justifyContent: "space-between",
        boxShadow: "none",
        borderRadius: 2,
        fontWeight: isSelected ? 500 : 300,
        opacity: isDisabled ? "0.4" : "1",
        border: isSelected
          ? `2px solid ${theme.palette.primary.main}`
          : `1px solid ${theme.palette.grey[300]}`,
        "&:hover": {
          backgroundColor: theme.palette.grey[100],
        },
        ...(isDisabled
          ? {
              backgroundColor: theme.palette.grey[100],
              filter: "grayscale(100%)",
            }
          : {}),
      })}
    >
      <Box
        width="100%"
        height="44px"
        display="flex"
        alignItems="center"
        p={({ spacing }) => spacing(1, 2, 1, 0)}
        gap={3}
      >
        <Box component="img" width="100px" src={imgSrc} aria-hidden alt="" />
        <Box width="100%" display="flex" justifyContent="space-between">
          {label}
          {isDisabled && (
            <Box>
              {t(Resources.Pages.Content.LicenseDetail.AwaitingPayment)}
            </Box>
          )}
        </Box>
      </Box>
    </Card>
  );
};
